import { useEffect, useState } from 'react'
import CustomTable from './CustomTable'
import { getTicketData } from '../Action/action';


function TicketDashboard() {

    const [data, setData] = useState([]);
    const [total,setTotal]=useState()
    const [filters, setFilters] = useState<any>({
      companyNames:[],
      ticketStatuses:[],
      ticketType:[],
      relationShipToSubscriber:[],
    }); 
    const [loading,setLoading]=useState(false)



const buildQueryParams=()=>{
    const queryParams = new URLSearchParams();
   
    Object.keys(filters).forEach((key) => {
      if (Array.isArray(filters[key])) {
        filters[key].forEach((value:any) =>
          queryParams.append(`${key}[]`, value)
        );
      } else {
        queryParams.append(key, filters[key]);
      }
    });

    return queryParams
}    

  

const fetchTicketData=async()=>{

    try { 
         
        const getQuery=buildQueryParams();  
        const res=await getTicketData(getQuery);
        // console.log('res:', res);
        setData(res.data);
        setTotal(res?.totals)        
    } catch (error) {
        console.log('error:', error);
        
    }
}



// useEffect(()=>{
  
//     // fetchTicketData();
//     //eslint-disable-next-line
// },[selectedDate,data]);
useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    await fetchTicketData();
    setLoading(false);
  };


  fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [ filters]);

  return (
    <div>
      <CustomTable  data={data}   filters={filters}   setFilters={setFilters}    loading={loading} total={total}/>
    </div>
  )
}

export default TicketDashboard
